export const ListaUrzedow = {
  gmina_ropczyce: {
    nazwa: 'Gmina Ropczyce',
    prefix: 'gmina_ropczyce',
    miejsceZalatwienia: 'Urząd Gminy w Ropczycach',
    miejscowosc: 'Ropczyce',
    ulica: 'Krisego',
    nrBudynku: '1',
    nrLokalu: '',
    teryt: 1815033,
    kod: '39-100',
    telefon: '(+48 17) 22-10-510',
    faks: '(+48 17) 22-10-555',
    strona: 'http://www.ropczyce.eu',
    stronaBIP: 'http://www.ropczyce.bip.gmina.pl',
    email: 'info@ropczyce.eu',
    przyjecia: {
      godzPracy: ['poniedziałek - 8.30 - 16.30', 'od wtorku do piątku - 7.30 - 15.30'],
      godzPrzyjec: ['poniedziałek - 14.00 - 16.00', 'piątek - 8.00 - 12.00'],
      kasa: ['poniedziałek - 8:30 - 16:00', 'od wtorku do piątku - 8.00 - 15.00'],
    },
    konto: [
      'Bank Spółdzielczy w Ropczycach:',
      'nr konta - opłata skarbowa: 51 9171 0004 0000 8136 2000 0610',
    ],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    euslugi: [
      'ZaswiadczenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'NrIPowDzialkiInfo',
      'WlasnoscDzialkiInfo',
      'ZagospDzialkiInfo',
      'PrzebiegDrogiInfo',
      'ZimoweUtrzymanieDrog',
      'PobierzWMSiWFS',
    ],
  },
  gmina_adamowka: {
    nazwa: 'Gmina Adamówka',
    prefix: 'gmina_adamowka',
    miejsceZalatwienia: 'Urząd Gminy Adamówka',
    miejscowosc: 'Adamówka',
    ulica: '',
    nrBudynku: '97',
    nrLokalu: '',
    teryt: 1814022,
    kod: '37-534',
    telefon: '(16) 622 90 01, (16) 622 90 11',
    faks: '016 622 90 01',
    strona: 'http://www.adamowka.pl/gmina/',
    stronaBIP: 'http://www.adamowka.pl/bip/',
    email: 'gmina@adamowka.pl',
    przyjecia: {
      godzPracy: ['od poniedziałku do piątku - 7.30 - 15.30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 91 9162 1010 2003 1500 0303 0001'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: ['PrzebiegDrogiInfo', 'ZimoweUtrzymanieDrog'],
    euslugi: [
      'ZaswiadczenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'NrIPowDzialkiInfo',
      'WlasnoscDzialkiInfo',
      'ZagospDzialkiInfo',
      'PrzebiegDrogiInfo',
      'ZimoweUtrzymanieDrog',
      'PobierzWMSiWFS',
    ],
  },
  gmina_orly: {
    nazwa: 'Gmina Orły',
    prefix: 'gmina_orly',
    miejsceZalatwienia: 'Urząd Gminy w Orłach',
    miejscowosc: 'Orły',
    ulica: 'Przemyska',
    nrBudynku: '3',
    nrLokalu: '',
    teryt: 1813072,
    kod: '37-716',
    telefon: '+48 (16) 671 26 93, (16) 671 26 94, (16) 736 24 36',
    faks: '+48 (16) 736 24 34',
    strona: 'http://www.gminaorly.pl',
    stronaBIP: 'http://www.bip.ugorly.pl/',
    email: 'urzad@ugorly.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 8:00-16:00', 'wtorek - piątek w godz. 7:15 do 15:15'],
      godzPrzyjec: [],
      kasa: ['poniedziałek: 8:30-14:45', 'wtorek - piątek w godz. 7:30 do 14:45'],
    },
    konto: [
      'Konto - Bank Spółdzielczy Żurawica oddział Orły Nr konta: 12 9113 1027 2005 3000 0045 0001',
    ],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: ['WlasnoscDzialkiInfo', 'PrzebiegDrogiInfo', 'ZimoweUtrzymanieDrog'],
    euslugi: [
      'ZaswiadczenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'NrIPowDzialkiInfo',
      'WlasnoscDzialkiInfo',
      'ZagospDzialkiInfo',
      'PrzebiegDrogiInfo',
      'ZimoweUtrzymanieDrog',
      'PobierzWMSiWFS',
    ],
  },
  gmina_cieszanow: {
    nazwa: 'Gmina Cieszanów',
    prefix: 'gmina_cieszanow',
    miejsceZalatwienia: 'Urząd Miasta i Gminy w Cieszanowie',
    miejscowosc: 'Cieszanów',
    ulica: 'Rynek',
    nrBudynku: '1',
    nrLokalu: '',
    teryt: 1809023,
    kod: '37-611',
    telefon: '(0-16) 631-10-76',
    faks: '(0-16) 631-14-40',
    strona: 'http://cieszanow.pl/',
    stronaBIP: 'http://www.bip.cieszanow.akcessnet.net/',
    email: 'cieszanow@vp.pl',
    przyjecia: {
      godzPracy: ['od poniedziałku do piątku - 7.00 - 15.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['nr konta: 09 9101 1042 2004 4400 0039 0001'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    euslugi: ['NrIPowDzialkiInfo', 'WlasnoscDzialkiInfo', 'ZagospDzialkiInfo'],
  },
  gmina_aleksandrow_lodzki: {
    nazwa: 'Gmina Aleksandrów Łódzki',
    prefix: 'gmina_aleksandrow_lodzki',
    miejsceZalatwienia: 'Urząd Gminy w Aleksandrowie Łódzkim',
    miejscowosc: 'Aleksandrów Łódzki',
    ulica: 'Plac Tadeusza Kościuszki',
    nrBudynku: '2',
    nrLokalu: '',
    teryt: 1020043,
    kod: '95-070',
    telefon: '(42) 2700 300',
    faks: '(42) 2700 313',
    strona: 'http://www.aleksandrow-lodzki.pl',
    stronaBIP: 'http://aleksandrowlodzki.bip.net.pl',
    email: 'gmina@aleksandrow-lodzki.pl',
    przyjecia: {
      godzPracy: [
        'Poniedziałek: 8-16',
        'Wtorek: 8-17',
        'Środa: 8-16',
        'Czwartek: 8-16',
        'Piątek: 8-15',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [
      'Bank Spółdzielczy w Aleksandrowie Łódzkim: 64 8780 0007 0000 0231 1000 0008',
      'W sprawach: podatek od nieruchomości, podatek rolny i leśny, podatek od środków transportowych, opłata skarbowa, opłata targowa, opłata za wieczyste użytkowanie gruntów, czynsz dzierżawny, należności z tytułu kupna mienia gminy, zezwolenia na sprzedaż i podawanie napojów alkoholowych, licencja na wykonywanie transportu drogowego taksówką, inne niepodatkowe należności',
      'Bank Spółdzielczy w Aleksandrowie Łódzkim: 37 8780 0007 0000 0231 1000 0009',
      'W sprawach: wadia, zabezpieczenia należytego wykonywania umów',
      'Bank Spółdzielczy w Aleksandrowie Łódzkim: 80 8780 0007 0000 0231 1000 0011',
      'W sprawach: opłata za udzielenie informacji o danych osobowo adresowych',
    ],
    footerLogo: 'http://aleksandrow-lodzki.pl/wp-content/uploads/2017/05/logotypy.png',
    disabledServices: [],
    euslugi: ['uproszczony_wypis', 'wypis_i_wyrys'],
  },
  gmina_grodzisko_dolne: {
    nazwa: 'Gmina Grodzisko Dolne',
    prefix: 'gmina_grodzisko_dolne',
    miejsceZalatwienia: 'Urząd Gminy w Grodzisku Dolnym',
    miejscowosc: 'Grodzisko Dolne',
    ulica: '',
    nrBudynku: '125a',
    nrLokalu: '',
    kod: '37-306',
    teryt: 1808022,
    telefon: '(+48) 17 242 82 65',
    faks: ' (+48) 17 243 60 38',
    strona: 'http://www.grodziskodolne.pl/',
    stronaBIP: 'http://bip.grodziskodolne.pl',
    email: 'urzad@grodziskodolne.pl',
    przyjecia: {
      godzPracy: [
        'Poniedziałek:  7:30 – 15:30',
        'Wtorek:  7:30 – 15:30',
        'Środa:  7:30 – 15:30',
        'Czwartek:  7:30 – 15:30',
        'Piątek:  7:30 – 15:30',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [
      'Bank Spółdzielczy w Leżajsku O/Grodzisko Dolne',
      'Nr Konta: 41 9187 1024 2003 2000 1270 0027',
    ],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    euslugi: [
      'ZaswiadczenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'NrIPowDzialkiInfo',
      'WlasnoscDzialkiInfo',
      'ZagospDzialkiInfo',
      'PrzebiegDrogiInfo',
      'ZimoweUtrzymanieDrog',
      'PobierzWMSiWFS',
    ],
  },
  gmina_stara_kamienica: {
    nazwa: 'Gmina Stara Kamienica',
    prefix: 'gmina_stara_kamienica',
    miejsceZalatwienia: 'Urząd Gminy Stara Kamienica',
    miejscowosc: 'Stara Kamienica ',
    ulica: '',
    nrBudynku: '41',
    nrLokalu: '',
    kod: '58-512',
    teryt: 206092,
    telefon: ' (4875) 7514337',
    faks: '',
    strona: 'www.starakamienica.pl',
    stronaBIP: 'http://stara-kamienica.bipgmina.pl/',
    email: 'starakamienica@starakamienica.pl',
    przyjecia: {
      godzPracy: [
        'Poniedziałek:  8:00 – 16:00',
        'Wtorek:  7:00 – 15:00',
        'Środa:  7:00 – 15:00',
        'Czwartek:  7:00 – 15:00',
        'Piątek:  7:00 – 15:00',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [
      'Bank urzędu gminy miasta Stara Kamienica',
      'Nr Konta: 90 2030 0045 1110 0000 0082 2500',
    ],
    footerLogo:
      'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    euslugi: ['ZaswiadczenieMPZP', 'WypisIWyrysZeStudium'],
  },
  radymno: {
    nazwa: 'Miasto Radymno',
    prefix: 'radymno',
    miejsceZalatwienia: 'Urząd Miasta Radymno',
    miejscowosc: 'Miasto Radymno',
    ulica: 'Lwowska',
    nrBudynku: '20',
    nrLokalu: '',
    kod: '37-550',
    teryt: 1804082,
    telefon: '(16) 628-15-89',
    faks: '(16) 628-24-17',
    strona: 'http://radymno.pl/',
    stronaBIP: 'http://www.radymno.biuletyn.net/',
    email: 'radymno@radymno.pl',
    przyjecia: {
      godzPracy: [
        'Poniedziałek:  7:15 – 15:15',
        'Wtorek: 8:00 – 16:00',
        'Środa: 7:15 – 15:15',
        'Czwartek: 7:15 – 15:15',
        'Piątek: 7:15 – 15:15',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto', ' 09 9101 1042 2004 4400 0039 0001'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: ['WlasnoscDzialkiInfo', 'PrzebiegDrogiInfo', 'ZimoweUtrzymanieDrog'],
    euslugi: [
      'ZaswiadczenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'NrIPowDzialkiInfo',
      'WlasnoscDzialkiInfo',
      'ZagospDzialkiInfo',
      'PrzebiegDrogiInfo',
      'ZimoweUtrzymanieDrog',
      'PobierzWMSiWFS'
    ],
  },
  gmina_sanok: {
    nazwa: 'Gmina Sanok',
    prefix: 'gmina_sanok',
    miejsceZalatwienia: 'Urząd Gminy w Sanoku',
    miejscowosc: 'Miasto Sanok',
    ulica: 'Kościuszki',
    nrBudynku: '23',
    nrLokalu: '',
    kod: '38-500',
    teryt: 1817052,
    telefon: '(013) 46-56-551',
    faks: '(013) 46-56-553',
    strona: 'http://www.gminasanok.pl/',
    stronaBIP: 'http://gmina.sanok.com.pl/bip/',
    email: 'ug_sanok@gminasanok.pl',
    przyjecia: {
      godzPracy: [
        'Poniedziałek:  7:30 – 15:30',
        'Wtorek: 7:30 – 15:30',
        'Środa: 7:30 – 15:30',
        'Czwartek: 7:30 – 15:30',
        'Piątek: 7:30 – 15:30',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto', 'Podkarpacki Bank Spółdzielczy 70 8642 1184 2018 0025 7912 0001'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [
      'ZaswiadczenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'NrIPowDzialkiInfo',
      'WlasnoscDzialkiInfo',
      'ZagospDzialkiInfo',
      'PrzebiegDrogiInfo',
      'ZimoweUtrzymanieDrog',
    ],
    euslugi: [
      'ZaswiadczenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'NrIPowDzialkiInfo',
      'WlasnoscDzialkiInfo',
      'ZagospDzialkiInfo',
      'PrzebiegDrogiInfo',
      'ZimoweUtrzymanieDrog',
      'PobierzWMSiWFS',
    ],
  },
  gmina_solina: {
    nazwa: 'Gmina Solina',
    prefix: 'gmina_solina',
    miejsceZalatwienia: 'Urząd Gminy w Solinie z/s w Polańczyku',
    miejscowosc: 'Solina',
    ulica: 'Wiejska',
    nrBudynku: '2',
    nrLokalu: '',
    kod: '38-610',
    teryt: 1821052,
    telefon: '(13) 469-21-18 lub 19',
    faks: '(13) 469-23-21',
    strona: 'http://esolina.pl/',
    stronaBIP: 'http://bip.solina.regiony.pl/',
    email: 'urzad@esolina.pl',
    przyjecia: {
      godzPracy: [''],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto', '91 8642 1012 2003 1206 0654 0001'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: ['WlasnoscDzialkiInfo', 'PrzebiegDrogiInfo', 'ZimoweUtrzymanieDrog'],
    euslugi: [
      'ZaswiadczenieMPZP',
      'WypisIWyrysZMpzp',
      'NrIPowDzialkiInfo',
      'WlasnoscDzialkiInfo',
      'ZagospDzialkiInfo',
      'PrzebiegDrogiInfo',
      'ZimoweUtrzymanieDrog',
      'PobierzWMSiWFS',
    ],
  },
  gmina_lask: {
    nazwa: 'Gmina Łask',
    prefix: 'gmina_lask',
    miejsceZalatwienia: 'Urząd Miejski w Łasku ',
    miejscowosc: 'Łask',
    ulica: 'Warszawska',
    nrBudynku: '14',
    nrLokalu: '',
    kod: '98-100',
    teryt: 1003023,
    telefon: '(43) 676-83-00',
    faks: '(43) 676-83-88',
    strona: 'http://www.lask.pl/',
    stronaBIP: 'http://www.bip.lask.pl/',
    email: 'um@lask.pl',
    przyjecia: {
      godzPracy: ['Od poniedziałku do piątku: 07:30 do 15:30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto', '91 1240 3288 1111 0000 2807 7365'],
    footerLogo: 'http://aleksandrow-lodzki.pl/wp-content/uploads/2017/05/logotypy.png',
    disabledServices: [],
    euslugi: [
      'WypisIWyrysZMpzp',
      'WypisIWyrysZeStudium',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
    ],
  },
  gmina_gorzyca: {
    nazwa: 'Gmina Górzyca',
    prefix: 'gmina_gorzyca',
    miejsceZalatwienia: 'Urząd Gminy w Górzycy ',
    miejscowosc: 'Górzyca',
    ulica: '1 Maja',
    nrBudynku: '1',
    nrLokalu: '',
    kod: '69-113',
    teryt: 805022,
    telefon: '+48 95 759 12 11',
    faks: '+48 95 783 65 07',
    strona: 'http://gmina.gorzyca.pl/',
    stronaBIP: 'http://gorzyca.bip.net.pl/',
    email: 'um@gorczyca.pl',
    przyjecia: {
      godzPracy: ['Od poniedziałku do piątku: 07:30 do 15:30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [''],
    footerLogo: 'http://rpo.lubuskie.pl/footer-portlet/images/pasek-RPO.jpg',
    disabledServices: [],
    euslugi: [],
  },
  gmina_lubomierz: {
    nazwa: 'Gmina Lubomierz',
    prefix: 'gmina_lubomierz',
    miejsceZalatwienia: 'Urząd Gminy i Miasta Lubomierz ',
    miejscowosc: 'Lubomierz',
    ulica: 'Plac Wolności',
    nrBudynku: '1',
    nrLokalu: '',
    kod: '59-623',
    teryt: 212023,
    telefon: '+48 757-833-151',
    faks: '+48 757-833-166',
    strona: 'http://www.lubomierz.pl/',
    stronaBIP: 'http://bip.lubomierz.pl/',
    email: 'ugim@lubomierz.pl',
    przyjecia: {
      godzPracy: [
        'Poniedziałek - 8:00-16:00',
        'Wtorek - Czwartek 7:30-15:30',
        'Piątek - 7:00-15:00',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Spółdzielczy', '81 8384 1022 0000 0811 2000 0007'],
    footerLogo:
      'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    euslugi: ['WypisIWyrysZMpzp', 'ZaswiadczenieMPZP'],
  },
  // gmina_mirsk: {
  //   nazwa: 'Gmina Mirsk',
  //   prefix: 'gmina_mirsk',
  //   miejsceZalatwienia: 'Urząd Miasta i Gminy Mirsk',
  //   miejscowosc: 'Mirsk',
  //   ulica: 'Plac Wolności',
  //   nrBudynku: '39',
  //   nrLokalu: '',
  //   kod: '59-630',
  //   teryt: 212043,
  //   telefon: '+48 756-470-440',
  //   faks: '+48 756-470-469',
  //   strona: 'http://www.mirsk.pl/',
  //   stronaBIP: 'http://bip.mirsk.pl',
  //   email: 'gmina@mirsk.pl',
  //   przyjecia: {
  //     godzPracy: ['poniedziałek – piątek 7.30 - 15.30'],
  //     godzPrzyjec: [],
  //     kasa: [],
  //   },
  //   konto: ['Nr. Konta', '68 1020 2124 0000 8102 0011 0221'],
  //   footerLogo:
  //     'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
  //   disabledServices: [],
  //   euslugi: ['WypisIWyrysZMpzp', 'ZaswiadczenieMPZP'],
  // },
  piechowice: {
    nazwa: 'Gmina Piechowice',
    prefix: 'piechowice',
    miejsceZalatwienia: 'Urząd Miasta w Piechowicach',
    miejscowosc: 'Piechowice',
    ulica: 'Kryształowa',
    nrBudynku: '49',
    nrLokalu: '',
    kod: '58-573',
    teryt: 206031,
    telefon: '+48 757-548-900',
    faks: '+48 757-612-274',
    strona: 'http://www.piechowice.pl/',
    stronaBIP: 'http://piechowice.bip.pbox.pl/public/',
    email: 'sekretariat@piechowice.pl',
    przyjecia: {
      godzPracy: ['poniedziałek 8.00-16.00', 'wtorek- piątek 7.30-15.30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Nr. Konta', '14 1020 5226 0000 6702 0463 4046'],
    footerLogo:
      'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    euslugi: ['WypisIWyrysZMpzp', 'ZaswiadczenieMPZP'],
  },
  gmina_wlen: {
    nazwa: 'Gmina Wleń',
    prefix: 'gmina_wlen',
    miejsceZalatwienia: 'Urząd Miasta i Gminy Wleń',
    miejscowosc: 'Wleń',
    ulica: 'Plac Bohaterów Nysy',
    nrBudynku: '7',
    nrLokalu: '',
    kod: '58-610',
    teryt: 212053,
    telefon: '+48 757-136-438',
    faks: '+48 757-136-438',
    strona: 'http://www.wlen.pl/',
    stronaBIP: 'http://wlen.bipgmina.pl/',
    email: 'sekretariat@wlen.pl',
    przyjecia: {
      godzPracy: [
        'poniedziałek od 8:00 do 17:00',
        'wtorek od 7:30 do 15:30',
        'środa od 7:30 do 15:30',
        'czwartek od 7:30 do 15:30',
        'piątek od 7:30 do 14:30',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Nr. Konta', '80 8384 1019 0000 0228 2000 0001'],
    footerLogo:
      'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    euslugi: ['WypisIWyrysZMpzp', 'ZaswiadczenieMPZP'],
  },
  boguszow_gorce: {
    nazwa: 'Boguszów-Gorce',
    prefix: 'boguszow_gorce',
    miejsceZalatwienia: 'Urząd Miejski w Boguszowie-Gorcach',
    miejscowosc: 'Boguszów-Gorce',
    ulica: 'Plac Odrodzenia',
    nrBudynku: '1',
    nrLokalu: '',
    kod: '58-370',
    teryt: 221011,
    telefon: '+48 74 84 49 311',
    faks: '+48 74 84 49 165',
    strona: 'www.boguszow-gorce.pl',
    stronaBIP: 'www.bip.boguszow-gorce.pl',
    email: 'sekretariat@boguszow-gorce.pl',
    przyjecia: {
      godzPracy: [
        'poniedziałek, środa, czwartek godz. 7:30 - 15:30',
        'wtorek godz. 7:30 - 17:00',
        'piątek godz. 7:30 - 14:00',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Nr. Konta', '52 1020 5095 0000 5302 0011 2367'],
    footerLogo: 'https://generator-efs.dwup.pl/Content/image/FE_PR-DS-UE_EFS-poziom-PL-kolor.jpg',
    disabledServices: [],
    euslugi: ['WypisIWyrysZMpzp'],
  },
  gmina_czarny_bor: {
    nazwa: 'Gmina Czarny Bór',
    prefix: 'gmina_czarny_bor',
    miejsceZalatwienia: 'Urząd Gminy Czarny Bór',
    miejscowosc: 'Czarny Bór',
    ulica: 'Główna',
    nrBudynku: '18',
    nrLokalu: '',
    kod: '58-379',
    teryt: 221042,
    telefon: '+48 74 8450 139',
    faks: '+48 74 8450 006',
    strona: 'www.czarny-bor.pl',
    stronaBIP: 'www.bip.czarny-bor.pl',
    email: 'sekretariat@czarny-bor.pl',
    przyjecia: {
      godzPracy: [
        'poniedziałek, środa, czwartek - w godz. 7.30 - 15.30 ',
        'wtorek - w godz. 7.30 - 16.30',
        'piątek- w godz. 7.30 - 14.30',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Nr. Konta', '51 8395 0001 0023 7158 2000 0003'],
    footerLogo:
      'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    // euslugi: [],
    euslugi: [
      'WypisZMpzp',
      'WyrysZeStudium',
      'WyrysZMpzp',
      'WypisZeStudium',
      'ZaswiadczenieMPZP',
      'ZagospDzialkiInfo',
    ],
  },
  gmina_pielgrzymka: {
    nazwa: 'Gmina Pielgrzymka',
    prefix: 'gmina_pielgrzymka',
    miejsceZalatwienia: 'Urząd Gminy w Pielgrzymce',
    miejscowosc: 'Pielgrzymka',
    ulica: '',
    nrBudynku: '109A/1',
    nrLokalu: '',
    kod: '59-524',
    teryt: 226032,
    telefon: '+48 76 877 50 13',
    faks: '+48 76 743 70 00',
    strona: 'www.pielgrzymka.biz',
    stronaBIP: 'www.bip.pielgrzymka.biz',
    email: 'sekretariat@pielgrzymka.biz ',
    przyjecia: {
      godzPracy: [
        'poniedziałek – środa: godz. 7:30 - 15:30',
        'czwartek: godz. 7:30 – 17:00',
        'piątek: godz. 7:30 - 14:00',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['PBS Złotoryja', '05 8658 0009 0019 7380 2000 0020'],
    footerLogo:
      'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    euslugi: [
      'WypisIWyrysZMpzp',
      'DecyzjeWZ',
      'DecyzjaSrodowiskowa',
      'ZaswiadczenieEMUIA',
      'DecyzjeULICP',
    ],
  },
  gmina_slubice_powiat_slubicki: {
    nazwa: 'Słubice',
    prefix: 'gmina_slubice_powiat_slubicki',
    miejsceZalatwienia: 'Urząd Miejski w Słubicach',
    miejscowosc: 'SŁubice',
    ulica: '',
    nrBudynku: '',
    nrLokalu: '',
    kod: '69-100',
    teryt: 805053,
    telefon: '',
    faks: '',
    strona: 'www.slubice.pl',
    stronaBIP: '',
    email: '',
    przyjecia: {
      godzPracy: [
        'poniedziałek – środa: godz. 7:30 - 15:30',
        'czwartek: godz. 7:30 – 17:00',
        'piątek: godz. 7:30 - 14:00',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [''],
    footerLogo: '',
    disabledServices: [],
    euslugi: [],
  },
  jawor: {
    nazwa: 'Miasto Jawor',
    prefix: 'jawor',
    miejsceZalatwienia: 'Urząd Miejski w Jaworze',
    miejscowosc: 'Jawor',
    ulica: 'Rynek',
    nrBudynku: '1',
    nrLokalu: '',
    kod: '59-400',
    teryt: 205011,
    telefon: '+48 76 870 20 21',
    faks: '+48 76 870 22 02',
    strona: 'www.jawor.pl',
    stronaBIP: 'www.jawor.bip.net.pl',
    email: 'um@jawor.pl',
    przyjecia: {
      godzPracy: [
        'poniedziałek, środa, czwartek: godz. 7:30 – 15:30',
        'wtorek: godz. 7:30 – 16:00',
        'piątek: godz. 7:30 – 15:00',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['', '27 1600 1462 1016 7777 4000 0009'],
    footerLogo:
      'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    euslugi: ['WypisIWyrysZMpzp', 'decyzje_su', 'wmc', 'wziulicp'],
  },
  gmina_msciwojow: {
    nazwa: 'Gmina Mściwojów',
    prefix: 'gmina_msciwojow',
    miejsceZalatwienia: 'Urząd Gminy Mściwojów',
    miejscowosc: 'Mściwojów',
    ulica: '',
    nrBudynku: '43',
    nrLokalu: '',
    kod: '59-407',
    teryt: 205042,
    telefon: '+48 76 878 85 20',
    faks: '+48 76 872 85 95',
    strona: 'www.msciwojow.pl',
    stronaBIP: 'www.bip.msciwojow.pl',
    email: 'ug@msciwojow.pl',
    przyjecia: {
      godzPracy: ['poniedziałek - piątek: godz. 7:00 – 15:00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Bank Spółdzielczy Jawor Oddział Mściwojów', '90 8647 1020 0210 0003 2002 0004'],
    footerLogo:
      'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    euslugi: ['WypisIWyrysZMpzp', 'decyzje_su', 'wmc', 'wziulicp'],
  },
  gmina_wadroze_wielkie: {
    nazwa: 'Gmina Wądroże Wielkie',
    prefix: 'gmina_wadroze_wielkie',
    miejsceZalatwienia: 'Urząd Gminy w Wądrożu Wielkim',
    miejscowosc: 'Wądroże Wielkie',
    ulica: '',
    nrBudynku: '64',
    nrLokalu: '',
    kod: '59-430',
    teryt: 205062,
    telefon: '+48 76 887 43 23',
    faks: '+48 76 887 43 25',
    strona: 'www.wadrozewielkie.pl',
    stronaBIP: 'www.bip.wadrozewielkie.pl',
    email: 'urzad@wadrozewielkie.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: godz. 7:00 – 17:00', 'wtorek - piątek: 7.30 – 15.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Bank Pocztowy S.A.', '91 1320 1999 2336 6129 2000 0002'],
    footerLogo:
      'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    euslugi: ['WypisIWyrysZMpzp', 'wziulicp', 'decyzje_su'],
  },
  krosno: {
    nazwa: 'Urząd Miasta Krosno',
    prefix: 'krosno',
    miejsceZalatwienia: 'Urząd Miasta Krosna',
    miejscowosc: 'Krosno',
    ulica: 'ul. Lwowska',
    nrBudynku: '28 A',
    nrLokalu: '',
    kod: '38-400',
    teryt: 1861011,
    telefon: '13 43 675 43',
    faks: '13 43 628 65',
    strona: 'http://krosno.pl/',
    stronaBIP: 'http://www.bip.umkrosno.pl/',
    email: 'um@um.krosno.pl',
    przyjecia: {
      godzPracy: [
        'Poniedziałek:  7:30 – 16:30',
        'Wtorek - Czwartek: 7:30 – 15:30',
        'Piątek: 7:30 – 14:30',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Bank Polska Kasa Opieki SA', '95 1240 1792 1111 0010 6149 6883'],
    footerLogo: 'http://mapa.inspire-hub.pl/upload/krosno_podkarpackie.jpg',
    disabledServices: [],
    euslugi: ['invest_contact'],
  },
  lubaczow: {
    nazwa: 'Miasto Lubaczów',
    prefix: 'lubaczow',
    miejsceZalatwienia: 'Urząd Miejski w Lubaczowie',
    miejscowosc: 'Lubaczów',
    ulica: 'Rynek',
    nrBudynku: '26',
    nrLokalu: '',
    kod: '37-600',
    teryt: 1809011,
    telefon: '+48 16 632 80 10',
    faks: '+48 16 632 11 91',
    strona: 'www.lubaczow.pl',
    stronaBIP: 'www.bip.um.lubaczow.pl',
    email: 'poczta@um.lubaczow.pl',
    przyjecia: {
      godzPracy: ['poniedziałek - piątek: w godz. 7.30 – 15:30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Bank Spółdzielczy w Lubaczowie', '62 9101 0003 2001 0011 8444 0002'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    euslugi: ['ZaswiadczenieMPZP', 'WypisIWyrysZMpzp', 'ZaswiadczenieStudium'],
  },
  gmina_lubaczow: {
    nazwa: 'Urząd Gminy Lubaczów',
    prefix: 'gmina_lubaczow',
    miejsceZalatwienia: 'Urząd Gminy Lubaczów',
    miejscowosc: 'Lubaczów',
    ulica: 'Jasna',
    nrBudynku: '1',
    nrLokalu: '',
    kod: '37-600',
    teryt: 1809042,
    telefon: '+48 16 632 16 84',
    faks: '+48 17 717  36 55',
    strona: 'www.lubaczow.com.pl',
    stronaBIP: 'www.bip.lubaczow.com.pl',
    email: 'urzad@lubaczow.com.pl',
    przyjecia: {
      godzPracy: ['poniedziałek – piątek: w godz. 7.00 – 15.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Powiatowy Bank Spółdzielczy w Lubaczowie', '54 9101 0003 2001 0007 1954 0001'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    euslugi: ['ZaswiadczenieMPZP', 'WypisIWyrysZMpzp', 'ZaswiadczenieStudium'],
  },
  gmina_horyniec_zdroj: {
    nazwa: 'Urząd Gminy Horyniec-Zdrój',
    prefix: 'gmina_horyniec_zdroj',
    miejsceZalatwienia: 'Urząd Gminy Horyniec-Zdrój',
    miejscowosc: 'Horyniec-Zdrój',
    ulica: 'Przyjaźni',
    nrBudynku: '5',
    nrLokalu: '',
    kod: '37-620',
    teryt: 1809032,
    telefon: '+48 16 631 34 55',
    faks: '+48 16 631 34 55',
    strona: 'www.horyniec-zdroj.pl',
    stronaBIP: 'www.bip.horyniec-zdroj.pl',
    email: 'ug@horyniec-zdroj.pl',
    przyjecia: {
      godzPracy: ['poniedziałek - piątek: w godz. 7.30 – 15:30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['BS Lubaczów o/Horyniec', '59 9101 1039 2002 2500 1195 0002'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    euslugi: ['ZaswiadczenieMPZP', 'WypisIWyrysZMpzp', 'ZaswiadczenieStudium'],
  },
  gmina_wielkie_oczy: {
    nazwa: 'Urząd Gminy w Wielkich Oczach',
    prefix: 'gmina_wielkie_oczy',
    miejsceZalatwienia: 'Urząd Gminy w Wielkich Oczach',
    miejscowosc: 'Wielkie Oczy',
    ulica: 'Leśna',
    nrBudynku: '2',
    nrLokalu: '',
    kod: '37-627',
    teryt: 1809082,
    telefon: '+48 16 631 01 26',
    faks: '+48 16 631 01 26',
    strona: 'www.wielkieoczy.info.pl',
    stronaBIP: 'bip.wielkieoczy.pl',
    email: 'ug@wielkieoczy.info.pl',
    przyjecia: {
      godzPracy: ['poniedziałek - piątek: w godz. 7.15 – 15:15'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [
      'Powiatowy Bank Spółdzielczy w Lubaczowie O/Wielkie Oczy',
      '54 9101 1013 2005 5100 2293 0001',
    ],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    euslugi: ['ZaswiadczenieMPZP', 'WypisIWyrysZMpzp', 'ZaswiadczenieStudium'],
  },
  gmina_siedlec: {
    nazwa: 'Urząd Gminy w Siedlcu',
    prefix: 'gmina_siedlec',
    miejsceZalatwienia: 'Urząd Gminy w Siedlcu',
    miejscowosc: 'Siedlec',
    ulica: 'Zbąszyńska',
    nrBudynku: '17',
    nrLokalu: '',
    kod: '64-212',
    teryt: 3029022,
    telefon: '+48 68 384 85 21',
    faks: '+48 68 384 84 73',
    strona: 'www.siedlec.pl',
    stronaBIP: 'www.siedlec.bip.net.pl',
    email: 'ug@siedlec.pl',
    przyjecia: {
      godzPracy: [
        'poniedziałek: w godz. 7.30 – 15:30',
        'wtorek: w godz. 7.30 – 17:00',
        'środa, czwartek: w godz. 7.30 – 15:30',
        'piątek: w godz. 7.30 – 14:00',
      ],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['BS SIEDLEC', '58 9660 0007 0000 0606 0200 0001'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    euslugi: ['WypisIWyrysZMpzp'],
  },
  gmina_zgorzelec: {
    nazwa: 'Gmina Zgorzelec',
    prefix: 'gmina_zgorzelec',
    miejsceZalatwienia: 'Urząd Gminy w Zgorzelcu',
    miejscowosc: 'Zgorzelec',
    ulica: 'Tadeusza Kościuszki',
    nrBudynku: '70',
    nrLokalu: '',
    kod: '59-900',
    teryt: 225072,
    telefon: '+48 75 772 14 00',
    faks: '+48 75 775 65 64',
    strona: 'www.gmina.zgorzelec.pl',
    stronaBIP: 'www.bip.gmina.zgorzelec.pl',
    email: 'gmina@gmina.zgorzelec.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: w godz. 8:00 – 16:00','wtorek - piątek: w godz. 7.30 – 15:30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Nr konta', '40 2030 0045 1110 0000 0189 7190'],
    footerLogo: 'https://www.kolejedolnoslaskie.eu/sites/default/files/o_spolce/fundusze%20unijne/logotyp%2012.jpg',
    disabledServices: [],
    euslugi: [
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'DecyzjaSrodowiskowa',
      'ZaswiadczenieEMUIA',
      'DecyzjeULICP',
      'DecyzjeWZ',
    ],
  },
  swiebodzice: {
    nazwa: 'Miasto Świebodzice',
    prefix: 'swiebodzice',
    miejsceZalatwienia: 'Urząd Miejski w Świebodzicach',
    miejscowosc: 'Świebodzice',
    ulica: '',
    nrBudynku: '',
    nrLokalu: '',
    kod: '',
    teryt: 219021,
    telefon: '+48 ',
    faks: '+48 ',
    strona: '',
    stronaBIP: '',
    email: '',
    przyjecia: {
      godzPracy: [],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [],
  },
  gmina_piecki: {
    nazwa: 'Gmina Piecki',
    prefix: 'gmina_piecki',
    miejsceZalatwienia: 'Urząd Gminy Piecki',
    miejscowosc: 'Piecki',
    ulica: 'Zwycięstwa',
    nrBudynku: '34',
    nrLokalu: '',
    kod: '11-710',
    teryt: 2810042,
    telefon: '+48 89 742 20 29',
    faks: '+48 89 742 20 65',
    strona: 'www.gminapiecki.pl',
    stronaBIP: 'www.bip.piecki.com.pl',
    email: 'gmina@piecki.com.pl',
    przyjecia: {
      godzPracy: ['poniedziałek:  8.00  - 16.00', 'wtorek - piątek: 7.15  - 15.15'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 08 9364 0000 2006 0001 0120 0013'],
    footerLogo: 'http://mapa.inspire-hub.pl/upload/rpo_mazury.jpg',
    disabledServices: [],
    euslugi: [
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
    ],
  },
  boleslawiec: {
    nazwa: 'Gmina Miejska Bolesławiec',
    prefix: 'boleslawiec',
    miejsceZalatwienia: 'Urząd Miasta Bolesławiec',
    miejscowosc: 'Bolesławiec',
    ulica: 'Rynek',
    nrBudynku: '41',
    nrLokalu: '',
    kod: '59-700',
    teryt: 201011,
    telefon: '+48 75 645 64 00',
    faks: '+48 75 645 64 02',
    strona: 'http://www.um.boleslawiec.pl',
    stronaBIP: 'http://www.um.boleslawiec.bip-gov.pl',
    email: 'umboleslawiec@um.boleslawiec.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 7.30 - 17.00', 'wtorek - czwartek: 7.30  - 15.30', 'piątek: 7.30 - 14.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['wpłaty z tytułu: \n\
    podatku od nieruchomości,\
    podatku od środków transportowych,\
    podatku rolnego,\
    podatku leśnego,\
    opłaty od posiadania psów,\
    opłaty skarbowej,\
    opłaty targowej,\
    opłat za zajęcie pasa drogowego,\
    opłat z tytułu pozwolenia na sprzedaż alkoholu,\
    opłat za wieczyste użytkowanie gruntów będących własnością gminy,\
    opłat z tytułu czynszu dzierżawnego gruntów będących własnością gminy,\
    opłat z tytułu przekształcenia wieczystego użytkowania gruntu w prawo własności,\
    opłat z tytułu wykupu gruntów na własność',
    'Konto: 98 1020 2137 0000 9002 0046 4230',
    'wpłaty z tytułu podatku od nieruchomości od osób prawnych i fizycznych',
    'Konto: 91 1020 2137 0000 9802 0046 4255',
    'depozyty - wadia, zabezpieczenia',
    'Konto: 04 1020 2137 0000 9402 0046 4271'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'ZmianaMPZP',
      'SporzadzenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      // Wniosek o zmianę studium
    ],
  },
  gmina_boleslawiec: {
    nazwa: 'Gmina Bolesławiec',
    prefix: 'gmina_boleslawiec',
    miejsceZalatwienia: 'Urząd Gminy Bolesławiec',
    miejscowosc: 'Bolesławiec',
    ulica: 'Teatralna',
    nrBudynku: '1A',
    nrLokalu: '',
    kod: '59-700',
    teryt: 201022,
    telefon: '+48 75 732 32 21 - 23',
    faks: '+48 75 735 17 83',
    strona: 'http://gminaboleslawiec.pl/231/strona-glowna.html',
    stronaBIP: 'http://bip.gminaboleslawiec.pl/8/strona-glowna-bip.html',
    email: 'urzadgminy@gminaboleslawiec.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 8.00 - 16.00', 'wtorek - piątek: 7.30  - 15.30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 29 8392 0004 2600 2017 2000 0010'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'ZmianaMPZP',
      'SporzadzenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      // Wniosek o zmianę studium
    ],
  },
  gmina_warta_boleslawiecka: {
    nazwa: 'Gmina Warta Bolesławiecka',
    prefix: 'gmina_wartwa_boleslawiecka',
    miejsceZalatwienia: 'Urząd Gminy Warta Bolesławiecka',
    miejscowosc: 'Warta Bolesławiecka',
    ulica: '',
    nrBudynku: '40C',
    nrLokalu: '',
    kod: '59-722',
    teryt: 201062,
    telefon: '+48 75 738 95 92, 75 738 95 97',
    faks: '+48 75 738 95 23',
    strona: 'http://wartaboleslawiecka.pl/index.php',
    stronaBIP: 'http://bip.wartaboleslawiecka.pl/',
    email: 'urzad@wartabol.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 7.30 - 15.30',
                  'wtorek: 7.30  - 15.30',
                  'środa - czwartek: 7.30 - 15.30',
                  'piątek: 7.30 - 15.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['podatku od nieruchomości,\
    podatku od środków transportowych,\
    podatku rolnego,\
    podatku leśnego,\
    opłaty targowej,\
    opłaty skarbowej,\
    opłaty za wydanie zezwolenia na sprzedaż napojów alkoholowych,\
    wieczyste użytkowanie,\
    czynsz dzierżawny,\
    opłaty za zagospodarowanie odpadów (tzw. podatek śmieciowy)',
    'Konto: 79 8658 1022 2600 0127 2000 0020',
    'opłaty z tytułu udostępniania danych z ewidencji ludności',
    'Konto: 16 8658 1022 0000 0127 2000 0010',
    'wadiów przetargowych,\
    kaucji',
    'Konto: 79 8658 1022 2600 0127 2000 0030'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'ZmianaMPZP',
      'SporzadzenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      // Wniosek o zmianę studium
    ],
  },
  gmina_osiecznica: {
    nazwa: 'Gmina Osiecznica',
    prefix: 'gmina_osiecznica',
    miejsceZalatwienia: 'Urząd Gminy w Osiecznicy',
    miejscowosc: 'Osiecznica',
    ulica: 'Lubańska',
    nrBudynku: '43',
    nrLokalu: '',
    kod: '59-724',
    teryt: 201052,
    telefon: '+48 (075) 731 21 07',
    faks: '+48 (075) 731 21 48',
    strona: 'http://www.osiecznica.pl/',
    stronaBIP: 'http://www.osiecznica.bip.net.pl/',
    email: 'info@osiecznica.pl',
    przyjecia: {
      godzPracy: ['poniedziałek - piątek: 7.30 - 15.30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 97 1020 2137 0000 9002 0108 8152'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'ZmianaMPZP',
      'SporzadzenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      // Wniosek o zmianę studium
    ],
  },
  gmina_zagrodno: {
    nazwa: 'Gmina Zagrodno',
    prefix: 'gmina_zagrodno',
    miejsceZalatwienia: 'Urząd Gminy Zagrodno',
    miejscowosc: 'Zagrodno',
    ulica: '',
    nrBudynku: '52',
    nrLokalu: '',
    kod: '59-516',
    teryt: 226052,
    telefon: '+48 (76) 877 33 96',
    faks: '+48 (76) 877 33 45',
    strona: 'http://www.zagrodno.eu/',
    stronaBIP: 'http://zagrodno.i-gmina.pl/',
    email: 'ugzagrodno@zagrodno.eu',
    przyjecia: {
      godzPracy: ['poniedziałek - piątek: 7.00 - 15.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 82 8658 0009 0017 3544 2000 0020'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'ZmianaMPZP',
      'SporzadzenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      // Wniosek o zmianę studium
    ],
  },
  zawidow: {
    nazwa: 'Gmina Zawidów',
    prefix: 'zawidow',
    miejsceZalatwienia: 'Urząd Gminy w Zawidowie',
    miejscowosc: 'Zawidów',
    ulica: 'Pl. Zwycięstwa',
    nrBudynku: '21',
    nrLokalu: '22',
    kod: '59-970',
    teryt: 225011,
    telefon: '+48 (75) 77 88 282, (75) 77 88 360',
    faks: '+48 (75) 77 88 205',
    strona: 'http://www.zawidow.info/index.php/pl/',
    stronaBIP: 'http://bip.zawidow.eu/',
    email: 'urzad@zawidow.eu',
    przyjecia: {
      godzPracy: ['poniedziałek: 8.00 - 16.00', 'wtorek - czwartek: 7.00 - 15.15', 'piątek: 7.00 - 14.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 32 1020 2137 0000 9102 0115 5621'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'ZmianaMPZP',
      'SporzadzenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      // Wniosek o zmianę studium
    ],
  },
  gmina_lwowek_slaski: {
    nazwa: 'Gmina Lwówek Sląski',
    prefix: 'gmina_lwowek_slaski',
    miejsceZalatwienia: 'Urząd Gminy i Miasta Lwówek Śląski',
    miejscowosc: 'Lwówek Śląski',
    ulica: 'Aleja Wojska Polskiego',
    nrBudynku: '25A',
    nrLokalu: '',
    kod: '59-600',
    teryt: 212033,
    telefon: '+48 75 647 78 88',
    faks: '+48 (75) 647 78 89',
    strona: 'https://lwowekslaski.pl/',
    stronaBIP: 'http://www.bip.lwowekslaski.pl/',
    email: 'sekretariat@lwowekslaski.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 8.00 - 16.00', 'wtorek - piątek: 7.15 - 15.15'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 47 1020 2137 0000 9002 0134 9109'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'ZmianaMPZP',
      'SporzadzenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      // Wniosek o zmianę studium
    ],
  },
  gmina_nowogrodziec: {
    nazwa: 'Gmina Nowogordziec',
    prefix: 'gmina_nowogrodziec',
    miejsceZalatwienia: 'Urząd Miejski w Nowogrodźcu',
    miejscowosc: 'Nowogrodziec',
    ulica: 'Rynek',
    nrBudynku: '1',
    nrLokalu: '',
    kod: '59-730',
    teryt: 201043,
    telefon: '+48 75 738 06 60',
    faks: '+48 75 731 64 16',
    strona: 'http://www.nowogrodziec.pl/',
    stronaBIP: 'http://bip.nowogrodziec.pl/7/strona-glowna-bip.html',
    email: 'urzad@nowogrodziec.pl',
    przyjecia: {
      godzPracy: ['poniedziałek - piątek: 7.30 - 15.30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 29 1090 1939 0000 0005 1604 5111'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'ZmianaMPZP',
      'SporzadzenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      // Wniosek o zmianę studium
    ],
  },
  gmina_gromadka: {
    nazwa: 'Gmina Gromadka',
    prefix: 'gmina_gromadka',
    miejsceZalatwienia: 'Urząd Gminy Gromadka',
    miejscowosc: 'Gromadka',
    ulica: 'gen. Wł. Sikorskiego',
    nrBudynku: '9',
    nrLokalu: '',
    kod: '59-730',
    teryt: 201032,
    telefon: '+48 75 73 82 452, 75 73 82 453, 75 73 82 417, 75 73 82 302',
    faks: '+48 75 73 82 472',
    strona: 'https://www.gromadka.pl/',
    stronaBIP: 'http://www.bip.gromadka.pl/',
    email: 'gmina@gromadka.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 8.00 - 16.00', 'wtorek - piątek: 7.00 - 15.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 08 8644 0000 0019 8000 2000 0020'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZmianaMPZP',
      'NrIPowDzialkiInfo',
      'ZagospDzialkiInfo'
      // Wniosek o zmianę studium
    ],
  },
  gmina_sulikow: {
    nazwa: 'Gmina Sulików',
    prefix: 'gmina_sulikow',
    miejsceZalatwienia: 'Urząd Gminy Sulików',
    miejscowosc: 'Sulików',
    ulica: 'Dworcowa',
    nrBudynku: '5',
    nrLokalu: '',
    kod: '59-975',
    teryt: 225052,
    telefon: '+48 75 77 87 288, 289',
    faks: '+48 75 77 56 922',
    strona: 'http://sulikow.pl/',
    stronaBIP: 'http://bip.sulikow.pl/',
    email: 'ug@sulikow.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 7.30 - 16.00', 'wtorek - czwartek: 7.30 - 15.30', 'piątek: 7.30 - 15.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 18 8392 0004 0000 0101 2000 0030'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [
      'ZmianaMPZP',
      'SporzadzenieMPZP',
      'WypisIWyrysZeStudium',
      'WypisIWyrysZMpzp',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      // Wniosek o zmianę studium
    ],
  },
  gmina_glogow_malopolski: {
    nazwa: 'Gmina Głogów Małopolski',
    prefix: 'gmina_glogow_malopolski',
    miejsceZalatwienia: 'Urząd Miejski w Głogowie Małopolskim',
    miejscowosc: 'Głogów Małopolski',
    ulica: 'Rynek',
    nrBudynku: '1',
    nrLokalu: '',
    kod: '36-060',
    teryt: 1816063,
    telefon: '+48 17 85 151 24',
    faks: '+48 17 85 151 20',
    strona: 'http://www.glogow-mlp.pl',
    stronaBIP: 'http://www.bip.glogow-mlp.pl/',
    email: 'umig@glogow-mlp.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 7.30 - 16.30', 'wtorek - czwartek: 7.30 - 15.30', 'piątek: 7.30 - 14.30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 1091 5900 0020 0100 0001 1400 01'],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    withoutPayment: {
      DecyzjeWZ: true,
      DecyzjeULICP: true,
      ZaswiadczenieEMUIA: true
    },
    euslugi: [
      'UsuniecieDrzew',
      'SporzadzenieMPZP',
      'OplataPlanistyczna',
      'UstalenieNumeruPorzadkowego',
      'ZezwolenieAlkohol',
      'ZmianaCeluPublicznego',
      'ZmianaWarunkowZabudowy',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      'WypisIWyrysZMpzp',
      'WypisIWyrysZeStudium',
      'DecyzjeWZ',
      'DecyzjeULICP',
      'ZaswiadczenieEMUIA',
      'ZmianaSUIKZP'
    ],
  },
  gmina_strzegom: {
    nazwa: 'Gmina Strzegom',
    prefix: 'gmina_strzegom',
    miejsceZalatwienia: 'Urzędu Miejski w Strzegomiu',
    miejscowosc: 'Strzegom',
    ulica: 'Rynek',
    nrBudynku: '38',
    nrLokalu: '',
    kod: '58-150',
    teryt: 219063,
    telefon: '(74) 85 60 599',
    faks: '(74) 85 60 516',
    strona: 'http://strzegom.pl/',
    stronaBIP: 'http://bip.strzegom.pl/',
    email: 'strzegom@strzegom.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 8.00 - 16.00', 'wtorek: 8.00 - 17.30', 'środa - czwartek: 8.00 - 16.00', 'piątek: 8.00 - 14.30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: ['Konto: 81 1090 2343 0000 0005 9800 0229'],
    footerLogo: 'http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png',
    disabledServices: [],
    euslugi: [],
  },
  gmina_krasne_rzeszow: {
    nazwa: 'Gmina Krasne',
    prefix: 'gmina_krasne_rzeszow',
    miejsceZalatwienia: 'Urzędu Gminy Krasne',
    miejscowosc: 'Krasne',
    ulica: '',
    nrBudynku: '121',
    nrLokalu: '',
    kod: '36-007',
    teryt: 1816092,
    telefon: '17 23-00-200',
    faks: '',
    strona: 'http://gminakrasne.pl/',
    stronaBIP: 'http://www.gminakrasne.pl/biuletyn-informacji-publicznej/',
    email: 'sekretariat@gminakrasne.pl',
    przyjecia: {
      godzPracy: ['poniedziałek - piątek: 7.30 - 15.30'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [],
    footerLogo: 'https://gw.podkarpackie.pl/images/UE-loga.png',
    disabledServices: [],
    euslugi: [
      'WypisIWyrysZMpzp',
      'WypisIWyrysZeStudium',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      'SporzadzenieMPZP',
      'ZmianaSUIKZP',
      'OplataPlanistyczna',
      'UstalenieNumeruPorzadkowego',
      'ZaswiadczenieEMUIA',
      'ZezwolenieAlkohol',
      'ZmianaWarunkowZabudowy',
      'DecyzjeULICP',
      'ZmianaCeluPublicznego',
      'UsuniecieDrzew',
    ],
  },
  skierniewice: {
    nazwa: 'Miasto Skierniewice',
    prefix: 'skierniewice',
    miejsceZalatwienia: 'Urząd Miasta Skierniewice',
    miejscowosc: 'Skierniewice',
    ulica: 'Rynek',
    nrBudynku: '1',
    nrLokalu: '',
    kod: '96-100',
    teryt: 1063011,
    telefon: '+48 (046) 834-51-00',
    faks: '+48 (046) 834-51-51',
    strona: 'http://skierniewice.eu/',
    stronaBIP: 'http://www.bip.um.skierniewice.pl/',
    email: 'umskier@um.skierniewice.pl',
    przyjecia: {
      godzPracy: ['poniedziałek - wtorek: 8.00 - 16.00', 'środa: 8.00 - 19.00', 'czwartek - piątek: 8.00 - 16.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [],
    footerLogo: 'http://aleksandrow-lodzki.pl/wp-content/uploads/2017/05/logotypy.png',
    disabledServices: [],
    euslugi: [
      'WypisIWyrysZMpzp'
    ],
  },
  gmina_tarnowo_podgorne: {
    nazwa: 'Gmina Tarnowo Podgórne',
    prefix: 'gmina_tarnowo_podgorne',
    miejsceZalatwienia: 'Urząd Gminy Tarnowo Podgórne',
    miejscowosc: 'Tarnowo Podgórne',
    ulica: 'Poznańska',
    nrBudynku: '115',
    nrLokalu: '',
    kod: '62-080',
    teryt: 3021172,
    telefon: '+48 61 895 92 00',
    faks: '+48 61 814 61 18',
    strona: 'www.tarnowo-podgorne.pl',
    stronaBIP: 'www.bip.tarnowo-podgorne.pl',
    email: 'ug@tarnowo-podgorne.pl',
    przyjecia: {
      godzPracy: ['poniedziałek: 8.30 - 18.00', 'wtorek - czwartek: 7.30 - 15.30', 'piątek: 7.30 - 14.00'],
      godzPrzyjec: [],
      kasa: [],
    },
    konto: [
      'ING Bank Śląski S.A. o/Poznań', 'PL 32 1050 1520 1000 0024 3672 4641'
    ],
    footerLogo: 'http://mapa.inspire-hub.pl/upload/rpo_wielkopolskie.jpg',
    disabledServices: [],
    euslugi: [
      'WypisIWyrysZMpzp',
      'WypisIWyrysZeStudium',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieStudium',
      'SporzadzenieMPZP',
      'ZmianaMPZP',
      'ZmianaSUIKZP',
      'DecyzjeWZ',
      'DecyzjeULICP',
      'ZmianaCeluPublicznego',
      'DecyzjaSrodowiskowa',
      'PrzeniesienieDecyzjiOWarunkachZabudowy',
      'ZmianaWarunkowZabudowy',
      'OplataPlanistyczna',
      'PrzeniesienieSrodowiskowychUwarunkowan'
    ],
  },
};



// WEBPACK FOOTER //
// src/routes/urzad/ListaUrzedow.js